"use client";

import React from "react";
import { buildTimezones, TimeZone } from "../date-time/buildTimezones";

export const useTimeZones = (): TimeZone[] => {
  const currentTime = new Date();
  // Optimization: only generate timezones once per hour, or once per component's life
  return React.useMemo(
    () => buildTimezones(currentTime),
    [currentTime.getHours()]
  );
};
